import { render } from "./Fab.vue?vue&type=template&id=06a124c2"
import script from "./Fab.vue?vue&type=script&lang=js"
export * from "./Fab.vue?vue&type=script&lang=js"

import "./Fab.vue?vue&type=style&index=0&id=06a124c2&lang=scss&global=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/common/components/Fab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06a124c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06a124c2', __exports__)) {
    api.reload('06a124c2', __exports__)
  }
  
  module.hot.accept("./Fab.vue?vue&type=template&id=06a124c2", () => {
    api.rerender('06a124c2', render)
  })

}


export default __exports__